module.exports = __webpack_public_path__ + "img/organisation_dashboard.647fddf1.jpg";